module.exports = __webpack_public_path__ + "img/82.26b40906.jpg";